/**
 * The Empress's theme (04 §5, 03 §5): an original tune, E minor, 160 BPM, 20 bars that loop at
 * exactly 30 seconds. Riff - climb - fall.
 *
 * The riff is a tight 3 + 3 + 2 figure that keeps coming back to E ("E E G, F# E B") over a
 * pounding bass, each bar answering a little higher until it breaks out over C and lands on B7.
 * The climb walks A minor and B7 up in long notes, twice, the second time to the top of the
 * range. The fall drops through E minor, D and C in held notes, tumbles down a C chord in
 * sixteenths and runs back up B7 into the riff. It never resolves: she is still there.
 */

import { CHARGE, STOMP, TACET, TRESILLO } from './grooves';
import type { Song } from './types';

export const EMPRESS: Song = {
  bpm: 160,
  loop: true,
  bassFloor: 38,
  arpFloor: 57,
  mix: { lead: 0.24, alto: 0.07, arp: 0.1, bass: 0.27, drum: 0.26 },
  order: ['riff', 'climb', 'fall'],
  patterns: {
    riff: {
      chords: 'Em | Em | C | D | Em | Em | C | B7',
      lead: `
        E5 . . E5 . . G5 . F#5 . . E5 . . B4 . |
        E5 . . E5 . . G5 . B5 . . A5 . . G5 . |
        E5 . . E5 . . G5 . C6 . . B5 . . G5 . |
        F#5 . . F#5 . . A5 . D6 . . . A5 . F#5 . |
        E5 . . E5 . . G5 . F#5 . . E5 . . B4 . |
        E5 . . E5 . . G5 . B5 . . D6 . . E6 . |
        G6 . . E6 . . C6 . G5 . . C6 . . E6 . |
        D#6 . . . B5 . . . F#5 . A5 . B5 . D#6 .`,
      bass: { groove: CHARGE },
      arp: TRESILLO,
    },
    climb: {
      chords: 'Am | B7 | Em | Em | Am | B7 | C | B7',
      lead: `
        A5 . . . C6 . . . E6 . . . C6 . A5 . |
        B5 . . . D#6 . . . F#6 . . . D#6 . B5 . |
        E6 . . D6 . . B5 . G5 . . B5 . . E5 . |
        G5 . F#5 . E5 . . . - . . . B4 . E5 . |
        A5 . . . C6 . . . E6 . . . A6 . . . |
        F#6 . . . D#6 . . . B5 . . . A5 . . . |
        G5 . C6 . E6 . G6 . . . E6 . C6 . G5 . |
        F#5 . B5 . D#6 . F#6 . . . D#6 . F#6 . A6 .`,
      bass: { groove: CHARGE },
    },
    fall: {
      chords: 'Em | D | C | B7',
      lead: `
        B6 . . . G6 . . . E6 . . . B5 . . . |
        A6 . . . F#6 . . . D6 . . . A5 . . . |
        G6 E6 C6 G5 E6 C6 G5 E5 C6 G5 E5 C5 G5 . . . |
        B4 D#5 F#5 A5 B5 D#6 F#6 A6 B6 . . . - . . .`,
      alto: `
        G6 . . . E6 . . . B5 . . . G5 . . . |
        F#6 . . . D6 . . . A5 . . . F#5 . . . |
        - . . . . . . . . . . . . . . . |
        - . . . . . . . . . . . . . . .`,
      bass: { groove: STOMP },
      arp: TACET,
    },
  },
};
